import React, { useRef, useState, useEffect, useCallback } from 'react';
import { NavLink } from "react-router-dom";
import FadeInSection from "../../FadeInup/FadeInup";

const BldcTechnology = () => {
    const videoRef = useRef(null);
    const sideTextRef = useRef(null);
    const [isSideTextVisible, setIsSideTextVisible] = useState(false);
    const [isVideoPlayed, setIsVideoPlayed] = useState(false);
    const [currentwidth, setCurrentwidth] = useState(window.innerWidth);

    // Use useCallback for the scroll handler to prevent unnecessary re-renders
    const handleScroll = useCallback(() => {
        const sideTextElement = sideTextRef?.current;
        const rect = sideTextElement?.getBoundingClientRect();
        const isVisible = rect?.top < window.innerHeight && rect?.bottom >= 0;

        setIsSideTextVisible(isVisible);
    }, []);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll]);

    useEffect(() => {
        if (isSideTextVisible && !isVideoPlayed) {
            setTimeout(() => {
                videoRef.current.play();
                setIsVideoPlayed(true);
            }, 1000)
        } else if (!isSideTextVisible && isVideoPlayed) {
            // videoRef.current.pause();
        }
    }, [isSideTextVisible, isVideoPlayed]);

    // Use useCallback for the video management function
    const handleVideoManagement = useCallback(() => {
        setCurrentwidth(window.innerWidth);
        const videos = document.querySelectorAll('video');

        const handlePlay = (event) => {
            const currentVideo = event.target;
            videos.forEach((video) => {
                if (video !== currentVideo) {
                    video.pause();
                }
            });
        };

        videos.forEach((video) => {
            video.addEventListener('play', handlePlay);
            video.addEventListener('pause', handlePlay);
        });

        return () => {
            videos.forEach((video) => {
                video.removeEventListener('play', handlePlay);
                video.removeEventListener('pause', handlePlay);
            });
        };
    }, []);

    useEffect(() => {
        const cleanup = handleVideoManagement();
        return cleanup;
    }, [handleVideoManagement]);

    // Memoize the video source URL to prevent unnecessary re-renders
    const videoSource = useCallback(() => {
        return currentwidth > 758 
            ? "https://colorbots3.s3.ap-south-1.amazonaws.com/Home-Page/Home-fan-transparent.mp4" 
            : "https://colorbots3.s3.ap-south-1.amazonaws.com/Home-Page/Home-fan-transparent-mobile.mp4";
    }, [currentwidth]);

    return (
        <div className="container-fluid">
            <div className='row pt-2 homeheight'>
                <video className='img-fluid hometrans' id='vedioplay' ref={videoRef} muted controls={false} playsInline>
                    <source src={videoSource()} type="video/mp4" alt="Transparent motor view of Colorbot Knoxx Ceiling fan" />
                </video>

                <div className="homealign">
                    <FadeInSection>
                        <div className={`hometext`}>
                            <h1 className="hometitle">Performance Leveled <span style={{ fontWeight: 600, color: "#16DFFF", marginLeft: "15px", marginRight: "15px", fontSize: "60px" }}>Up</span> <img src='https://colorbots3.s3.ap-south-1.amazonaws.com/Vector.svg' className='img-fluid' alt='vector' width="25" height="29" />
                            </h1>
                            <h2 className="mainsubtitle">Empowered by BLDC technology</h2>
                            <br />
                            <br />
                            <p className="homesubtitle">
                                <p className='homeleft'>
                                    Every Colorbot BLDC is equipped with the advanced Color-B algorithm for a ceaseless comfort.
                                    The powerful BLDC motors enable smooth and noiseless operation of your fan while ensuring
                                    consistent airflow and adequate air delivery even at fluctuating voltages and on the inverter
                                </p>
                                <br />
                                <NavLink to="/technology" className="homemore">Know more.</NavLink>
                            </p>
                        </div>
                    </FadeInSection>
                </div>

                <div className="homealign1" id="sidetext" ref={sideTextRef}>
                    <FadeInSection>
                        <div className={`hometext mt-5 pt-5`}>
                            <br /><br /><br />
                            <h2 className="hometitle"><span style={{ color: "#16DFFF", marginRight: "15px", fontSize: "60px", fontWeight: 600 }}>Zero</span> Carbon Footprint</h2>
                            <h3 className="mainsubtitle">Sustainable Solution</h3>
                            <br />
                            <br />
                            <p className="homesubtitle">
                                <p className='homeleft'>
                                    Colorbot is committed to promoting planet-friendly steps towards protecting the environment.
                                    Apart from saving electricity, use of one Colorbot BLDC fan can reduce around 1 Kg of CO2 emission
                                    per year. This makes Colorbot Fans the sustainable choice for your home.
                                </p>
                                <br />
                                <NavLink to="/sustainability" className="homemore">Know more.</NavLink>
                            </p>
                        </div>
                    </FadeInSection>
                </div>
            </div>
        </div>
    );
};

export default React.memo(BldcTechnology);
